export const PermissionReadRepositoryToken = Symbol('PermissionReadRepository');
export const PermissionWriteRepositoryToken = Symbol('PermissionWriteRepository');
export const UserWriteRepositoryToken = Symbol('UserWriteRepository');
export const InvitationSenderToken = Symbol('InvitationSender');
